import React, { useState, useEffect } from 'react';
import Icon from '../../utils/icons';
import './TVHeader.css';

function TVHeader({
  currentLocation,
  currentIndex,
  totalLocations,
  lastUpdated,
  cycleEnabled,
  viewMode,
  onToggleCycle,
  onToggleFullscreen,
  onChangeView,
  isFullscreen
}) {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update clock every second
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <header className="tv-header">
      <div className="tv-header-left">
        <div className="tv-logo">
          <Icon name="building" size={32} />
          <span className="tv-logo-text">Data Center Weather</span>
        </div>
        {currentLocation && viewMode === 'single' && (
          <div className="tv-location-info">
            <Icon name="mapPin" size={20} />
            <span className="tv-current-location">{currentLocation}</span>
            <span className="tv-location-count">
              {currentIndex + 1} of {totalLocations}
            </span>
          </div>
        )}
      </div>

      <div className="tv-header-center">
        <div className="tv-clock">
          <span className="tv-time">{formatTime(currentTime)}</span>
          <span className="tv-date">{formatDate(currentTime)}</span>
        </div>
      </div>

      <div className="tv-header-right">
        <div className="tv-status">
          <div className={`tv-status-indicator ${cycleEnabled ? 'cycling' : 'paused'}`}>
            <span className="status-dot"></span>
            <span className="status-text">{cycleEnabled ? 'Auto-Cycling' : 'Paused'}</span>
          </div>
          {lastUpdated && (
            <div className="tv-last-update">
              <Icon name="refresh" size={14} />
              <span>Updated {lastUpdated.toLocaleTimeString()}</span>
            </div>
          )}
        </div>

        <div className="tv-controls">
          <button
            className={`tv-control-btn ${viewMode === 'single' ? 'active' : ''}`}
            onClick={() => onChangeView('single')}
            title="Single View"
          >
            <Icon name="monitor" size={18} />
          </button>
          <button
            className={`tv-control-btn ${viewMode === 'grid' ? 'active' : ''}`}
            onClick={() => onChangeView('grid')}
            title="Grid View"
          >
            <Icon name="grid" size={18} />
          </button>
          <button
            className={`tv-control-btn ${viewMode === 'overview' ? 'active' : ''}`}
            onClick={() => onChangeView('overview')}
            title="Overview"
          >
            <Icon name="layout" size={18} />
          </button>
          <div className="tv-control-divider"></div>
          <button
            className={`tv-control-btn ${cycleEnabled ? 'active' : ''}`}
            onClick={onToggleCycle}
            title={cycleEnabled ? 'Pause' : 'Play'}
          >
            <Icon name={cycleEnabled ? 'pause' : 'play'} size={18} />
          </button>
          <button
            className="tv-control-btn"
            onClick={onToggleFullscreen}
            title={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
          >
            <Icon name={isFullscreen ? 'minimize' : 'maximize'} size={18} />
          </button>
        </div>
      </div>
    </header>
  );
}

export default TVHeader;